import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { ROUTES } from '@/constants/routes'

const PAGE_BACK_MAPPING = {
  [ROUTES.PHONE_OTP]: ROUTES.LOGIN,
  [ROUTES.OTP_VERIFICATION]: ROUTES.EMAIL_VERIFICATION
}

const useBackNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname

  const goBack = useCallback(() => {
    const backRoute = PAGE_BACK_MAPPING[pathname]

    if (backRoute) {
      navigate(backRoute)
    } else {
      globalThis.history.back()
    }
  }, [navigate, pathname])

  return { goBack }
}

export default useBackNavigation
